import { AgencyMemberFragment } from '@gql'
import { createModel } from '../../../store/generic'

export default createModel<AgencyMemberFragment>()
